import {
	TLanguageIDs,
	TFileId,
	ICountriesAndCities,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	TTypeOfServiceProvided,
	IMerchantCategoryCode,
	IDefaultTips,
	IMerchantCategoryCodeForUpdate,
	IStyleSettingColors,
	IMediaSettings,
	IDocumentSettings,
	IStyleSettings,
	IMediaSettingsForUpdate,
	IDocumentSettingsForUpdate,
	IDishComboItem,
	IRestaurantDishSubCategory,
	IRestaurantDish,
	ISuggestedDish,
	IDishModification,
	IAdditionalDish,
	IDishModifierGroup,
	TWordingLevel,
	IBpaShort,
	EntityStatus,
} from 'types';

export enum AcquirerType {
	QR = 'QR',
	EMV = 'EMV',
}

export type TMenuContentVersion = 'None' | 'Customer' | 'Restaurant';

export type TPosSystemId = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18;
// 1 - Iiko; 2 - Rkeeper; 3 - Servio; 4 - Untill; 5 - Stable; 6 - Hypersoft; 7 - RkeeperFastFood;
// 8 - Aloha; 9 - Micros; 10 - Access; 11 - 3Spos; 12 - Deliverect; 13 - Dotykacka; 14 - Zonal;
// 15 - Square; 16 - Flipdish; 17 - Foodhub; 18 - Notepos;

export interface IPosSystemType {
	posSystemID: TPosSystemId;
	posSystemName: string;
}

export type TAdditionalApplications = 'VivaWallet' | 'M4' | 'TBank' | 'Toucan';

export interface IAdditionalApplicationsType {
	additionalApplicationID: TAdditionalApplications;
	additionalApplicationName: string;
}

export interface IRestaurantBankSettingsAcquirer {
	id: string;
	type: AcquirerType;
	name: Nullable<string>;
	allowGlobalMerchant: boolean;
}

export interface IRestaurantManagers {
	restaurantId: string;
	userId: string;
	firstName: string;
}

export interface IRestaurantsLanguages {
	restaurantId: string;
	languageId: TLanguageIDs;
	languageName: string;
}

export interface IRestaurantCategory {
	id: string;
	name: string;
}

export interface IParentCustomer {
	id: string;
	name: Nullable<string>;
	defaultTip: Nullable<number>;
	tips: Nullable<string>;
	isShowLoyaltyProgramButtons: boolean;
	isActiveBpa: boolean;
}

export type TTlsCertificateLevel = 'None' | 'Restaurant' | 'Device';

export interface ITlsCertificateLevelType {
	id: TTlsCertificateLevel;
	name: string;
}

export interface IItemRestaurant {
	id: string;
	name: string;
	shortName: string;
	address: string;
	customerId: string;
	customer: IParentCustomer;
	countryId: string;
	country: ICountriesAndCities;
	cityId: string;
	city: ICountriesAndCities;
	email: Nullable<string>;
	code: Nullable<string>;
	loyalty: number | null;
	defaultLanguageId: string;
	languageName: Nullable<string>;
	generatedWatchCommandsLink: Nullable<string>;
	isoCurrencySymbol: string;
	posSystemId: null | TPosSystemId;
	restaurantType: TTypeOfServiceProvided;
	restrictionQrValue: Nullable<string>;
	usePosPhotos: boolean;
	updateOfTheLauncher: boolean;
	launcherSettingFilePath: Nullable<string>;
	restaurantManagers: IRestaurantManagers[];
	restaurantLanguages: IRestaurantsLanguages[];
	deviceAmount: number;
	categories: IRestaurantCategory[];
	lastMenuSyncDate: Nullable<string>;
	cardAcceptorId: Nullable<string>;
	cardAcceptorName: Nullable<string>;
	terminalId: Nullable<string>;
	terminal: null | number;
	timeBlock: null | number;
	insertedBy: string;
	insertedDate: string;
	updatedBy: Nullable<string>;
	updatedDate: Nullable<string>;
	archivedBy: Nullable<string>;
	archivedDate: Nullable<string>;
	deletedBy: Nullable<string>;
	deletedDate: Nullable<string>;
	priceType: Nullable<string>;
	isUsedCustomerPriceType: boolean;
	downloadAppAndroidUrl: Nullable<string>;
	downloadAppIosUrl: Nullable<string>;
	useTlsCertificate: boolean;
	tlsCertificateLevel: TTlsCertificateLevel;
	tlsCertificateName: Nullable<string>;
	tlsCertificateFilePath: Nullable<string>;
	vatId: Nullable<string>;
	kmVatId: Nullable<string>;
	bpaSet: Nullable<IBpaShort>;
	sendDeviceUnavailabilityAlerts: boolean;
}

export interface IRestaurants {
	restaurantCount: number;
	restaurants: IItemRestaurant[];
}

export interface ISupplier {
	name: Nullable<string>;
	taxpayerId: Nullable<string>;
	phone: Nullable<string>;
}

export interface IFranchiseCommission {
	percent: Nullable<number>;
	fixedAmount: Nullable<number>;
	fixedAmountThreshold: Nullable<number>;
}

interface IVivaWalletIsv {
	sourceId: string;
	isvSourceId: Nullable<string>;
	isvPercent: number;
	isvFixedFeeAmount: number;
	isvFixedFeeThreshold: number;
	pinCode: Nullable<string>;
	franchiseCommission: Nullable<IFranchiseCommission>;
}

export type TCommissionTariff = 'GENERAL' | 'KATEMEDIA';

export interface ICharityAmount {
	amount: Nullable<number>;
	isDefault: boolean;
}

export interface IDataGetRestaurantInfo extends IItemRestaurant {
	categories: IItemForGetShortInfo[];
	syncStopList: boolean;
	useCustomerStopListSyncInterval: boolean;
	stopListSyncIntervalMinutes: Nullable<number>;
	masterPhoneNumber: Nullable<string>;
	merchantCategoryCode: IMerchantCategoryCode;
	useCustomerMcc: boolean;
	isUsedCustomerTips: boolean;
	defaultTips: IDefaultTips[];
	tipsCommissionPercent: Nullable<number>;
	tipsCommissionMaxValue: Nullable<number>;
	commissionTariff: TCommissionTariff;
	isShowLoyaltyProgramButtons: boolean;
	additionalApplications: TAdditionalApplications[];
	vivaWalletIsv: Nullable<IVivaWalletIsv>;
	supplier: Nullable<ISupplier>;
	isOpenPriceServiceCharge: Nullable<boolean>;
	openPricePercent: Nullable<number>;
	useMenuVersion: TMenuContentVersion;
	useContentVersion: TMenuContentVersion;
	customerMenuVersion: Nullable<string>;
	customerContentVersion: Nullable<string>;
	restaurantMenuVersion: Nullable<string>;
	restaurantContentVersion: Nullable<string>;
	isApplicableForVat: boolean;
	paymentTypeId: Nullable<string>;
	extraPaymentTypes: {
		[key: string]: string;
	};
	isCharityEnabled: boolean;
	charityName: Nullable<string>;
	charityLogoPath: Nullable<string>;
	charityAmounts: ICharityAmount[];
}

export interface IGetRestaurantInfo {
	data: {
		restaurant: IDataGetRestaurantInfo;
	};
}

export interface IGetPaginatedRestaurants {
	pageNumber: number;
	pageSize: number;
	searchByName: Nullable<string>;
	customerId: Nullable<string>;
	countryId: Nullable<string>;
	cityId: Nullable<string>;
	clientTypes: TTypeOfServiceProvided[];
	status: EntityStatus;
	sortByName: null | 'NameA-Z' | 'NameZ-A';
	sortByCustomer: null | 'CustomerA-Z' | 'CustomerZ-A';
	sortByCountry: null | 'CountryA-Z' | 'CountryZ-A';
	sortByCity: null | 'CityA-Z' | 'CityZ-A';
}

export interface ICreateRestaurant {
	name: string;
	address: string;
	customerId: string;
	countryId: string;
	cityId: string;
	email: Nullable<string>;
	code: Nullable<string>;
	defaultLanguageId: string;
	posSystemId: null | TPosSystemId;
	restaurantType: TTypeOfServiceProvided;
	isoCurrencySymbol: string;
	priceType: Nullable<string>;
	isUsedCustomerPriceType: boolean;
}

export interface IRestaurantBankSettingsForUpdateRestaurant {
	id: Nullable<string>;
	merchantName: Nullable<string>;
	priority: number;
	merchantId: Nullable<string>;
	acquirerId: Nullable<string>;
	paymentTemplateFilePath: Nullable<string>;
	sbpAccount: Nullable<string>;
	sbpUserLogin: Nullable<string>;
}

export interface IUpdateRestaurant {
	restaurantId: string;
	name: string;
	shortName: string;
	address: string;
	customerId: string;
	countryId: string;
	cityId: string;
	email: Nullable<string>;
	code: Nullable<string>;
	additionalApplications: TAdditionalApplications[];
	vivaWalletIsv: Nullable<IVivaWalletIsv>;
	supplier: Nullable<ISupplier>;
	isOpenPriceServiceCharge: Nullable<boolean>;
	openPricePercent: Nullable<number>;
	loyalty: number;
	defaultLanguageId: string;
	posSystemId: null | TPosSystemId;
	isUsedCustomerTips: boolean;
	defaultTips: IDefaultTips[];
	tipsCommissionPercent: Nullable<number>;
	tipsCommissionMaxValue: Nullable<number>;
	commissionTariff: TCommissionTariff;
	downloadAppAndroidUrl: Nullable<string>;
	downloadAppIosUrl: Nullable<string>;
	restaurantType: TTypeOfServiceProvided;
	isoCurrencySymbol: string;
	masterPhoneNumber: Nullable<string>;
	cardAcceptorId: Nullable<string>;
	cardAcceptorName: Nullable<string>;
	terminalId: Nullable<string>;
	terminal: null | number;
	timeBlock: null | number;
	restrictionQrValue: Nullable<string>;
	usePosPhotos: boolean;
	syncStopList: boolean;
	useCustomerStopListSyncInterval: boolean;
	stopListSyncIntervalMinutes: Nullable<number>;
	updateOfTheLauncher: boolean;
	launcherSettingFileId: Nullable<string>;
	restaurantsLanguages: string[];
	priceType: Nullable<string>;
	isUsedCustomerPriceType: boolean;
	merchantCategoryCode: IMerchantCategoryCodeForUpdate;
	useCustomerMcc: boolean;
	isShowLoyaltyProgramButtons: boolean;
	useMenuVersion: TMenuContentVersion;
	useContentVersion: TMenuContentVersion;
	menuVersion: Nullable<string>;
	contentVersion: Nullable<string>;
	useTlsCertificate: boolean;
	tlsCertificateLevel: TTlsCertificateLevel;
	tlsCertificateName: Nullable<string>;
	tlsCertificateFileId: Nullable<string>;
	tlsCertificateFileHash: Nullable<string>;
	vatId: Nullable<string>;
	kmVatId: Nullable<string>;
	bpaSetId: Nullable<string>;
	isApplicableForVat: boolean;
	sendDeviceUnavailabilityAlerts: boolean;
	paymentTypeId: Nullable<string>;
	extraPaymentTypes: {
		[key: string]: string;
	};
	isCharityEnabled: boolean;
	charityName: Nullable<string>;
	charityLogoFileId: Nullable<string>;
	charityAmounts: ICharityAmount[];
}

export type TMenuApiVersion = 'v1' | 'v2';

export interface IGetRestaurantsShortArgs {
	customerId: string;
	menuApiVersion?: TMenuApiVersion;
}

export interface IGetRestaurantsShort {
	data: {
		restaurants: IItemForGetShortInfoWithStatus[];
	};
}

export interface IItemForGetRestaurantDishes {
	id: string;
	name: Nullable<string>;
	posName: Nullable<string>;
	posShortDescription: Nullable<string>;
	shortDescription: Nullable<string>;
	filePath: Nullable<string>;
	externalId: Nullable<string>;
	isCombo: boolean;
	insertedBy: Nullable<string>;
	updatedBy: Nullable<string>;
	insertedDate: string;
	updatedDate: Nullable<string>;
	comboItem: IDishComboItem;
	subCategories: IRestaurantDishSubCategory[];
	restaurantsDishes: IRestaurantDish[];
	suggestedDishes: ISuggestedDish[];
	dishModifications: IDishModification[];
	additionalDishes: IAdditionalDish[];
	modifierGroups: IDishModifierGroup[];
}

export interface IGetRestaurantDishes {
	data: {
		dishes: IItemForGetRestaurantDishes[];
		dishesCount: number;
	};
}

export interface IRestaurantLocalizationItemTranslation {
	id: Nullable<string>;
	languageId: TLanguageIDs;
	value: Nullable<string>;
}

export interface IRestaurantLocalizationItem {
	id: Nullable<string>;
	key: Nullable<string>;
	label: Nullable<string>;
	level: TWordingLevel;
	translations: IRestaurantLocalizationItemTranslation[];
}

export interface IRestaurantLocalizationGroup {
	id: Nullable<string>;
	name: Nullable<string>;
	items: IRestaurantLocalizationItem[];
}

export interface IRestaurantLocalizationInfo {
	ownerId: string;
	ownerType: 1 | 2;
	useCustomerSettings: boolean;
	groups: IRestaurantLocalizationGroup[];
}

export interface IGetRestaurantLocalizationInfo {
	data: IRestaurantLocalizationInfo;
}

export interface IGetRestaurantLocalizationInfoArgs {
	customerID: string;
	restaurantID: string;
	useCustomerSettings?: boolean;
}

export interface ICreateRestaurantLocalizationTranslation {
	label: Nullable<string>;
	value: Nullable<string>;
	languageId: TLanguageIDs;
}

export interface ICreateRestaurantLocalization {
	groupId: string;
	key: string;
	translations: ICreateRestaurantLocalizationTranslation[];
	restaurantId: string;
}

export interface IUpdateRestaurantLocalization {
	ownerId: string;
	useCustomerSettings: boolean;
	groups: IRestaurantLocalizationGroup[];
}

export interface IAdditionalSettingForRestaurantStylesInfo {
	id: string;
	key: Nullable<string>;
	filePath: Nullable<string>;
}

export interface IAdditionalSettingForRestaurantStylesInfoForUpdate {
	id: Nullable<string>;
	key: Nullable<string>;
	fileId: TFileId;
}

export interface IRestaurantStylesInfo {
	ownerId: string;
	styleSettingColors: IStyleSettingColors;
	mediaSettings: IMediaSettings[];
	documentSettings: IDocumentSettings[];
	useCustomerSettings: boolean;
	additionalSetting: IAdditionalSettingForRestaurantStylesInfo;
}

export interface IGetRestaurantStylesInfo {
	data: IRestaurantStylesInfo;
}

export interface IUpdateRestaurantStyles {
	ownerId: string;
	styleSettings: IStyleSettings[];
	mediaSettings: IMediaSettingsForUpdate[];
	documentSettings: IDocumentSettingsForUpdate[];
	useCustomerSettings: boolean;
	additionalSetting: IAdditionalSettingForRestaurantStylesInfoForUpdate;
}

export interface ICreateRestaurantWatchesCommandsFile {
	watchesQuantity: number;
	adminWatchesQuantity: number;
	watchesCommands: TWatchesCommandsTypes[];
	watchesTableRanges: string[];
	adminWatchesTableRanges: Nullable<string>;
}

export type TWatchesCommandsTypes =
	| 'BatteryOverheated'
	| 'CallWaiter'
	| 'CreateOrder'
	| 'OrderPaid'
	| 'Error'
	| 'AlcoholVerification';

export interface IWatchesCommandsType {
	id: TWatchesCommandsTypes;
	name: string;
	disabled: boolean;
}

export enum RestaurantNotificationEventType {
	PushUpdateAllSettings = 'PushUpdateAllSettings',
	PushUpdateMainSettings = 'PushUpdateMainSettings',
	PushUpdateGames = 'PushUpdateGames',
	PushUpdateConfigurationFile = 'PushUpdateConfigurationFile',
	PushUpdateRestaurantSettings = 'PushUpdateRestaurantSettings',
	PushUpdateRestaurantMenu = 'PushUpdateRestaurantMenu',
	PushRestaurantMenu = 'PushRestaurantMenu',
	PushCloseDay = 'PushCloseDay',
	PushRestartApp = 'PushRestartApp',
	PushDownloadFirmware = 'PushDownloadFirmware',
	PushUpdateLauncherConfig = 'PushUpdateLauncherConfig',
	PushRebootDevices = 'PushRebootDevices',
	PushShutdownDevices = 'PushShutdownDevices',
	PushPriceUpdate = 'PushPriceUpdate',
	PushUpdateEncryptedPaymentConfig = 'PushUpdateEncryptedPaymentConfig',
	PushUpdateTeasers = 'PushUpdateTeasers',
	PushUpdateVideos = 'PushUpdateVideos',
	PushDmsNetworkParams = 'PushDmsNetworkParams',
	SynchronizationMenu = 'SynchronizationMenu',
	SyncRestaurantMenu = 'SyncRestaurantMenu',
	PushUpdateTlsCertificate = 'PushUpdateTlsCertificate',
}

export interface IPushNotification {
	eventType: RestaurantNotificationEventType;
	restaurantIds?: string[];
	forceReload?: boolean;
	metadata?: {
		useExtendedTimeout?: boolean;
	};
}

export interface IGetPaginatedRestaurantSoftwareUpdates {
	restaurantId: string;
	pageNumber: number;
	pageSize: number;
	searchByName: Nullable<string>;
	sortName: null | 'Name1-10' | 'Name10-1';
	sortLastUpdateDate: null | 'LastUpdate1-10' | 'LastUpdate10-1';
	sortUpdateBy: null | 'UpdatedByA-Z' | 'UpdatedByZ-A';
	sortSoftwareType: null | 'SoftwareTypeA-Z' | 'SoftwareTypeZ-A';
}

export type TSoftwareType = 1 | 2;

export interface ISoftwareType {
	id: TSoftwareType;
	name: string;
}

export interface IItemSoftwareUpdate {
	id: string;
	name: Nullable<string>;
	lastUpdateDate: string;
	updateBy: Nullable<string>;
	softwareType: TSoftwareType;
}

export interface ISoftwareUpdates {
	items: IItemSoftwareUpdate[];
	count: number;
}

export interface IGetPaginatedRestaurantDevices {
	restaurantID?: string;
	pageNumber: number;
	pageSize: number;
	searchByName: Nullable<string>;
	showFreeDevices: boolean | null;
	sortByHardwareId: null | 'HardwareIdA-Z' | 'HardwareIdZ-A';
	sortByTerminalId: null | 'TerminalId1-10' | 'TerminalId10-1';
}

export interface IItemRestaurantDevice {
	id: string;
	hardwareId: string;
	terminalIds: string[];
	isAssigned: boolean;
	tableName: Nullable<string>;
}

export interface IRestaurantDevices {
	count: number;
	items: IItemRestaurantDevice[];
}

export interface IDeviceForAssign {
	id: string;
	isAssigned: boolean;
}

export interface IAssignDevices {
	restaurantId: string;
	devices: IDeviceForAssign[];
}

export interface ILatestSoftwareUpdateInfo {
	lastFimrwareAssignedDate: Nullable<string>; // BE typo
	lastFirmwareAssignedBy: Nullable<string>;
	lastFirmwareVersionName: Nullable<string>;
	tabletAppAssignedDate: Nullable<string>;
	lastTabletAppAssignedBy: Nullable<string>;
	lastTabletAppVersionName: Nullable<string>;
	lastMenuSyncDate: Nullable<string>;
}

export interface IGetLatestSoftwareUpdateInfo {
	data: ILatestSoftwareUpdateInfo;
}

export interface IRestaurantsCopyMenu {
	fromRestaurantId: string;
	toRestaurantIds: string[];
}

export type TTypeOfReport = 'Detailed' | 'Period' | 'OrderTips' | 'TermsAndConditions' | 'OrderWithError' | 'Fees';

export interface IReportType {
	reportTypeID: TTypeOfReport;
	reportTypeName: string;
}

export type TTypeOfSchedule = 'Daily' | 'Weekly' | 'Monthly';

export interface IScheduleType {
	scheduleTypeID: TTypeOfSchedule;
	scheduleTypeName: string;
}

export interface IRestaurantReportsInfo {
	id: string;
	reportType: TTypeOfReport;
	scheduleTypes: TTypeOfSchedule[];
	emails: string[];
	copyEmails: string[];
	isShiftsWorking: boolean;
}

export interface IGetReportsInfo {
	data: IRestaurantReportsInfo;
}

export interface IGetRestaurantReportsInfo {
	data: {
		reports: IRestaurantReportsInfo[];
	};
}

export interface ICreateRestaurantReports {
	restaurantId: string;
	reportType: TTypeOfReport;
	scheduleTypes: TTypeOfSchedule[];
	emails: string[];
	copyEmails: string[];
	isShiftsWorking: boolean;
}

export interface IUpdateRestaurantReports {
	id: string;
	scheduleTypes: TTypeOfSchedule[];
	emails: string[];
	copyEmails: string[];
	isShiftsWorking: boolean;
}

export interface IAdyen {
	merchantAccount: Nullable<string>;
	store: Nullable<string>;
	apiKey: Nullable<string>;
	checkoutUrlPrefix: Nullable<string>;
	splitPayments3S: boolean;
	merchantBalanceAccountId: Nullable<string>;
	kmBalanceAccountId: Nullable<string>;
}

export type TYandexPaymentType = 'Split' | 'Card';

export interface IRestaurantBankSettings {
	id: string;
	paymentTemplateFilePath: Nullable<string>;
	logoPath: Nullable<string>;
	merchantName: Nullable<string>;
	priority: Nullable<string>;
	merchantId: Nullable<string>;
	acquirer: Nullable<IRestaurantBankSettingsAcquirer>;
	sbpAccount: Nullable<string>;
	sbpUserLogin: Nullable<string>;
	yandexApiKey: Nullable<string>;
	yandexPaymentTypes: Nullable<TYandexPaymentType[]>;
	vivaApiKey: Nullable<string>;
	vivaApiSecret: Nullable<string>;
	yandexChequeApiToken: Nullable<string>;
	yandexChequeApiPartnerId: Nullable<string>;
	accNumber: Nullable<string>;
	sector: Nullable<number>;
	sdRef: Nullable<string>;
	isTipsSupported: boolean;
	isFeeFiscalized: boolean;
	generateQrInstantly: boolean;
	paymentTypeId: Nullable<string>;
	adyen: Nullable<IAdyen>;
	smsCode: Nullable<string>;
	tBankPlaceId: Nullable<string>;
	masterWallet: Nullable<string>;
}

export interface IExtendedRestaurantBankSettings extends IRestaurantBankSettings {
	isVivaSecretUpdated: boolean;
	isYandexChequeSecretUpdated: boolean;
}

export interface IRestaurantBankSettingsForUpdate {
	id: Nullable<string>;
	paymentTemplateFilePath: Nullable<string>;
	logoPath: Nullable<string>;
	merchantName: Nullable<string>;
	priority: number | null;
	merchantId: Nullable<string>;
	acquirerId: Nullable<string>;
	sbpAccount: Nullable<string>;
	sbpUserLogin: Nullable<string>;
	yandexApiKey: Nullable<string>;
	yandexPaymentTypes: TYandexPaymentType[] | null;
	vivaApiKey: Nullable<string>;
	vivaApiSecret: Nullable<string>;
	isVivaSecretUpdated: boolean;
	yandexChequeApiToken: Nullable<string>;
	yandexChequeApiPartnerId: Nullable<string>;
	isYandexChequeSecretUpdated: boolean;
	accNumber: Nullable<string>;
	sector: Nullable<number>;
	sdRef: Nullable<string>;
	isTipsSupported: boolean;
	isFeeFiscalized: boolean;
	generateQrInstantly: boolean;
	paymentTypeId: string;
	adyen: Nullable<IAdyen>;
	tBankPlaceId: Nullable<string>;
	masterWallet: Nullable<string>;
}

export interface IGetRestaurantBankSettings {
	data: {
		restaurantBankSettings: IRestaurantBankSettings[];
	};
}

export interface IUpdateRestaurantBankSettings {
	restaurantId: string;
	restaurantBankSettings: IRestaurantBankSettingsForUpdate[];
}

export interface IGetRestaurantTlsCertificateInfo {
	data: {
		useTlsCertificate: boolean;
		tlsCertificateLevel: TTlsCertificateLevel;
		tlsCertificateName: Nullable<string>;
	};
}

export enum NfcCardPermission {
	None = 'None',
	UnlockOrderPayment = 'UnlockOrderPayment',
}

export interface IRestaurantNfcCards {
	uuid: Nullable<string>;
	cardHolder: Nullable<string>;
	permissions: NfcCardPermission[];
}

export interface IExtendedRestaurantNfcCards extends IRestaurantNfcCards {
	id: string;
}

export interface IGetRestaurantNfcCards {
	data: {
		nfcCards: IRestaurantNfcCards[];
	};
}

export interface IRestaurantNfcCardsForUpdate {
	uuid: string;
	cardHolder: string;
	permissions: NfcCardPermission[];
}

export interface IUpdateRestaurantNfcCards {
	restaurantId: string;
	restaurantNfcCards: IRestaurantNfcCardsForUpdate[];
}
